import {useCallback, useContext} from 'react';
import {
  FetchDataError, GenericErrors, NetworkError,
  interpolateRoute, request, responseBodyErrorsAsArray
} from 'apstra-ui-common';

import IBAContext from '../IBAContext';
import MultiUploadModal from '../../components/MultiUploadModal';

function UploadErrorComponent({error}) {
  if (error instanceof NetworkError) {
    const {response, responseBody} = error;
    if (response && response.status === 422 && responseBody && responseBody.errors) {
      return <GenericErrors errors={responseBodyErrorsAsArray(responseBody.errors, 'dashboard')} />;
    }
  }
  return <FetchDataError error={error} />;
}

export default function DashboardBatchImportModal(props) {
  const {blueprintId, routes} = useContext(IBAContext);

  const importDashboard = useCallback(({file, signal}) => request(
    interpolateRoute(routes.dashboardImport, {blueprintId}),
    {method: 'POST', body: file, signal}
  ), [blueprintId, routes]);

  return (
    <MultiUploadModal
      header='Import Dashboards'
      description='Drag and drop dashboard files here or click the button below.'
      successNotificationText='Dashboards imported successfully'
      action='Import'
      accept={{'application/json': [], 'text/plain': []}}
      uploadFile={importDashboard}
      UploadErrorComponent={UploadErrorComponent}
      {...props}
    />
  );
}
